import permissions from "@/router/userPermissions";

export default [
  {
    path: "assets",
    name: "assets",
    component: () => import("@/modules/hollymontt-admin/views/AssetsCrud.vue"),
    meta: {
      auth: permissions.scopes.admin,
      serviceName: "assets",
      title: "Activos",
    },
  },
];
